<template>
  <div class="bar-options-data-dialog colorfff6">
    <chart-common-options-data :options="options"></chart-common-options-data>
  </div>
</template>

<script>
import ChartCommonOptionsData from "toolbarComponents/bigScreen/common/chart-common-options-data"
export default {
  name: "bar-options-data",
  components: { ChartCommonOptionsData },
  props: { options: Object },
  data() {
    return {}
  },
  comments: {},

  mounted() {},
  methods: {}
}
</script>

<style scoped></style>
